import React from "react";
import Button from "@mui/material/Button";
import "./ButtonCompo.css";


const ButtonCompo = ({ typeOfBtn, btnText, onClick, disabledButton, btnOutlined, greyOutlined }) => {
  return disabledButton ? (
    <div className="btn-container">
      <Button type={typeOfBtn} className="background-butn-disabled" disabled>
        {btnText}{" "}
      </Button>
    </div>
  ) : btnOutlined ? (
    <div className="btn-container">
      <Button type={typeOfBtn} className="background-butn-outlined" onClick={onClick}>
        {btnText}{" "}
      </Button>
    </div>
  ) : greyOutlined ? (
    <div className="btn-container">
      <Button type={typeOfBtn} className="background-butn-grey-outlined" onClick={onClick}>
        {btnText}{" "}
      </Button>
    </div>
  ) : (
    <div className="btn-container">
      <Button type={typeOfBtn} className="background-butn" onClick={onClick}>
        {btnText}{" "}
      </Button>
    </div>
  )

};

export default ButtonCompo;
